import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import {CartService} from '@nuskin/ns-shop';
import {events} from '@nuskin/ns-util';
import template from './ns-mini-cart.html';

/**
 * This is the ns-mini-cart component.
 * <ns-mini-cart></ns-mini-cart>
 */
export class NsMiniCart extends PolymerElement {
    static get is() {
        return "ns-mini-cart";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            href: {
                type: String,
                value: "/content/nuskin/en_US/cart.html"
            },
            cartCount: {
                type: String,
                reflectToAttribute: true
                // observer: '_updateCartCount'
            },
            devMode: {
                type: Boolean,
                value: false
            },
            shoppingBagText: {
                type: String,
                value: ''
            },
            showShoppingBagText: {
                type: Boolean,
                value: false
            }
        }
    }

    constructor() {
        super()
    }

    ready() {
        super.ready();
        this.cartCount = CartService.getCartInfo().qty;
        this._setCartIcon();
        this._setupListener();
    }

    _updateCartCount(newValue, oldValue) {
        var that = this;
        if (this.devMode) {
            that.shadowRoot.querySelector('.cart-image').classList.remove('cart-changed');
            setTimeout(function() {
                that.shadowRoot.querySelector('.cart-image').classList.add('cart-changed');
            }, 1);
        } else {
            if (newValue !== that.cartCount) {
                that.cartCount = newValue;
                that.shadowRoot.querySelector('.cart-image').classList.remove('cart-changed');
                setTimeout(function() {
                    that.shadowRoot.querySelector('.cart-image').classList.add('cart-changed');
                }, .3);
            }
            that._setCartIcon();
        }
    }

    _setupListener() {
        let that = this;
        events.subscribe(events.shop.CART_UPDATED, (info) => {
            if (info && info.cartInfo.qty !== undefined) {
                that._updateCartCount((info.cartInfo.qty > 0) ? info.cartInfo.qty : "");
            }
        });
    }

    _setCartIcon() {
        if (this.cartCount > 99) {
            this.cartCount = 99;
            this.cartIcon = 'nuskin:icon-largecart-99p';
        } else if (this.cartCount > 0) {
            this.cartIcon = 'nuskin:icon-largecart-099';
        } else {
            this.cartIcon = 'nuskin:icon-largecart-empty';
        }
    }
}
customElements.define(NsMiniCart.is, NsMiniCart);
